// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2497":"5847fb97","7408":"3d2146bf","8277":"e095baa4"}[chunkId] + ".chunk.css";
};